// PDF Export via Backend API (bypasses iframe sandbox restrictions)
const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

const periodQuery = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const exportSEOPDF = async (clientId, startDate, endDate) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${API_URL}/export/seo/${clientId}${periodQuery(startDate, endDate)}`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || "Erro ao exportar PDF");
  }
  
  const blob = await response.blob();
  const filename = response.headers.get("Content-Disposition")?.split("filename=")[1] || "relatorio-seo.pdf";
  
  // Create download link
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const exportAdsPDF = async (clientId, startDate, endDate) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${API_URL}/export/ads/${clientId}${periodQuery(startDate, endDate)}`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || "Erro ao exportar PDF");
  }
  
  const blob = await response.blob();
  const filename = response.headers.get("Content-Disposition")?.split("filename=")[1] || "relatorio-ads.pdf";
  
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const exportEmailPDF = async (clientId, startDate, endDate) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${API_URL}/export/email/${clientId}${periodQuery(startDate, endDate)}`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || "Erro ao exportar PDF");
  }
  
  const blob = await response.blob();
  const filename = response.headers.get("Content-Disposition")?.split("filename=")[1] || "relatorio-email.pdf";
  
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// Utility functions (kept for other uses)
export const formatNumber = (num) => {
  if (num === undefined || num === null || isNaN(num)) return '0';
  return Number(num).toLocaleString('pt-PT');
};

export const formatPercent = (num) => {
  if (num === undefined || num === null || isNaN(num)) return '0%';
  return `${Number(num).toFixed(2)}%`;
};

export const formatCurrency = (num) => {
  if (num === undefined || num === null || isNaN(num)) return '0,00€';
  return `${Number(num).toLocaleString('pt-PT', { minimumFractionDigits: 2 })}€`;
};

export const calculateChange = (current, previous, lowerIsBetter = false) => {
  if (!previous || previous === 0) return current > 0 ? 100 : 0;
  const change = ((current - previous) / previous) * 100;
  return lowerIsBetter ? -change : change; // Invert for metrics where lower is better
};

// Converts a month ("01".."12" or "all") + year ("2026" or "all") selection into a date range
export const monthYearToRange = (month, year) => {
  if (year === "all" || !year) return { startDate: "", endDate: "" };
  if (month === "all" || !month) return { startDate: `${year}-01-01`, endDate: `${year}-12-31` };
  const lastDay = new Date(Number(year), Number(month), 0).getDate();
  return { startDate: `${year}-${month}-01`, endDate: `${year}-${month}-${lastDay}` };
};

export const availableYears = (reports) =>
  [...new Set((reports || []).map((r) => r.period_start?.slice(0, 4)).filter(Boolean))].sort().reverse();

const MONTH_LABELS = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

// "2026-07-01" -> "Julho 2026"
export const monthLabel = (periodStart) => {
  if (!periodStart) return "";
  const [year, month] = periodStart.split("-");
  return `${MONTH_LABELS[Number(month) - 1]} ${year}`;
};

// Report immediately before `current` in the full (date-desc) list, ignoring the active filter
export const previousMonthReport = (reports, current) => {
  if (!current) return undefined;
  const index = (reports || []).findIndex((r) => r.id === current.id);
  return index === -1 ? undefined : reports[index + 1];
};

export const filterByDateRange = (reports, startDate, endDate) => {
  if (!startDate && !endDate) return reports;
  
  return reports.filter(report => {
    const reportStart = new Date(report.period_start);
    const reportEnd = new Date(report.period_end);
    
    if (startDate && endDate) {
      return reportStart >= new Date(startDate) && reportEnd <= new Date(endDate);
    }
    if (startDate) {
      return reportStart >= new Date(startDate);
    }
    if (endDate) {
      return reportEnd <= new Date(endDate);
    }
    return true;
  });
};
